

export const SEARCH_ADDRESS = 'SEARCH_ADDRESS'
export const COMPLETE_ADDRESS_FETCH = 'COMPLETE_ADDRESS_FETCH'

export const SELECTED_JUSO = 'SELECTED_JUSO'



// WEBPACK FOOTER //
// ./src/actions/types.js